export const getAnnexeCategorySuggestions = payload => {
  return {
    type: "FETCH_ANNEXE_CATEGORY_SUGGESTIONS",
    payload
  };
};

export const getEnabledAnnexeCategories = payload => {
  return {
    type: "FETCH_ENABLED_ANNEXE_CATEGORIES",
    payload
  };
};

export const setAnnexeCategory = items => {
  return {
    type: "SET_ANNEXE_CATEGORY_SUGGESTIONS",
    items
  };
};

export const setEnabledAnnexeCategories = items => {
  return {
    type: "SET_ENABLED_ANNEXE_CATEGORIES",
    items
  };
};

export const getAnnexeCategories = payload => {
  return {
    type: "FETCH_ANNEXE_CATEGORIES",
    payload
  };
};

export const setAnnexeCategories = items => {
  return {
    type: "SET_ANNEXE_CATEGORIES",
    items
  };
};

export const initAnnexeCategories = () => {
  return {
    type: "INIT_ANNEXE_CATEGORIES"
  };
};

export const setModifiedCategories = modified => {
  return {
    type: "SET_MODIFIED_CATEGORIES",
    modified
  };
};

export const setStandardCategories = standard => {
  return {
    type: "SET_STANDARD_CATEGORIES",
    standard
  };
};

export const setCreatedCategories = created => {
  return {
    type: "SET_CREATED_CATEGORIES",
    created
  };
};

export const setLabelsForm = labelsForm => {
  return {
    type: "SET_LABELS_FORM",
    labelsForm
  };
};

export const updateAnnexeCategoriesState = resp => ({
  type: "UPDATE_ANNEXE_CATEGORIES_STATE",
  payload: resp
});

export const updateAnnexeCategory = resp => ({
  type: "UPDATE_ANNEXE_CATEGORY",
  payload: resp
});

export const saveAnnexeCategory = resp => ({
  type: "SAVE_ANNEXE_CATEGORY",
  payload: resp
});

export const deleteAnnexeCategory = resp => ({
  type: "DELETE_ANNEXE_CATEGORY",
  payload: resp
});



// WEBPACK FOOTER //
// ./src/actions/actions/annexeCategory.js